import React, {useCallback, useEffect, useMemo, useState} from "react";
import HomeMenu from "../../component/home/HomeMenu";
import HomeFooter from "../../component/home/HomeFooter";
import _ from "lodash";
import {HomeContentScrollClass, HomeContentScrollContainer} from "../../component/home/variable/HomeContentType";
import useModal from "../../hook/useModal";
import {HOME_ACCOUNT_SETTING_MODAL_ID} from "../../component/home/HomeAccountSettingModal";
import {scrollToElement} from "../../util/animateScroll";
import useHumanWheelChecker from "../../hook/useHumanWheelChecker";
import HeroPage from "./contentPage/HeroPage";
import DataSourceInfoPage from "./contentPage/DataSourceInfoPage";
import ReplyQuestionInfoPage from "./contentPage/ReplyQuestionInfoPage";
import FAQInfoPage from "./contentPage/FAQInfoPage";
import WebchatInfoPage from "./contentPage/WebchatInfoPage";
import SubscriptionPage from "./contentPage/SubscriptionPage";

const HomeView: React.FC = () => {
    const modal = useModal();
    const { check: checkWheelEvent } = useHumanWheelChecker();

    const [isLgWidth, setIsLgWidth] = useState<boolean>(window.innerWidth >= 1024);

    const usePageScroll = useMemo(() => {
        return !modal.status[HOME_ACCOUNT_SETTING_MODAL_ID] && isLgWidth;
    }, [modal.status, isLgWidth])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const movePage =  useCallback(_.throttle((isScrollingDown: boolean) => {
        const scrollContainer = document.querySelector(`#${HomeContentScrollContainer}`)!
        const scrollElements = Array.from(document.getElementsByClassName(HomeContentScrollClass) || []);
        scrollElements.sort((a, b) => {
            return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
        });

        let currentSectionIdx = null;
        // @ts-ignore
        for (const [index, section] of scrollElements.entries()) {
            if (section.getBoundingClientRect().top >= 0) {
                currentSectionIdx = index;
                break;
            }
        }
        if (currentSectionIdx === null) return;

        const targetSection = scrollElements[currentSectionIdx! + (isScrollingDown ? 1 : -1)];
        targetSection && scrollToElement(targetSection, scrollContainer);
    }, 100), [])

    useEffect(() => {
        const wheelEvent = (e: any) => {
            if (e.ctrlKey) return;
            e.preventDefault();

            if (checkWheelEvent(e, "y")) {
                movePage(e.deltaY > 0);
            }
        }

        const KeyEvent = (e: any) => {
            switch (e.key) {
                case 'ArrowUp':
                case 'ArrowDown':
                    e.preventDefault();
                    movePage(e.key === 'ArrowDown');
                    break;
                default:
                    break;
            }
        };

        const checkWindowWidth = () => {
            setIsLgWidth(window.innerWidth >= 1024);
        }

        window.addEventListener('resize', checkWindowWidth);
        if (usePageScroll) {
            window.addEventListener('wheel', wheelEvent, {passive: false});
            window.addEventListener('keydown', KeyEvent);
        } else {
            window.removeEventListener('wheel', wheelEvent);
            window.removeEventListener('keydown', KeyEvent);
        }

        return () => {
            window.removeEventListener('resize', checkWindowWidth);
            window.removeEventListener('wheel', wheelEvent);
            window.removeEventListener('keydown', KeyEvent);
        }
    }, [movePage, usePageScroll, checkWheelEvent])

    return (
        <div id={HomeContentScrollContainer} className={"relative h-full w-screen overflow-y-auto overflow-x-auto lg:overflow-x-hidden"}>
            <HomeMenu/>
            <div className={"bg-console-gray"}>
                <HeroPage />
                <DataSourceInfoPage />
                <ReplyQuestionInfoPage />
                <FAQInfoPage />
                <WebchatInfoPage />
                <SubscriptionPage />
            </div>
            <HomeFooter/>
            {/*<HomeWebchat />*/}
            {/*TODO uncomment after setting up SiteBunny chatbot*/}
        </div>
    );
}

export default HomeView;
